export const HOMEPAGE = process.env.REACT_APP_HOME_PAGE;

export const ROUTES = {
	HOME: '/',
	INSCRIPCION_DETALLE: 'baja-inscrito/:inscripcionId',
	LISTADO_INSCRITOS: 'listado-inscritos',
};
